






































import {
  defineComponent,
  ref,
  useContext,
  useRouter,
  useStore,
  computed,
} from '@nuxtjs/composition-api'
import { debounce } from 'throttle-debounce'
import {
  AdaptedOfficeOption,
  RegionOption,
} from '../FormInput/BlockNearestOffice.typing'
import InputSelect from '../Inputs/InputSelect.vue'
import { defineProps } from '@/helpers/defineProps'
import Popup from '@/packages/basis/components/Popup.vue'
import SectionOffices from '@/views/SectionOffices.vue'
import {
  AdaptedOffice,
  Office,
  officeListAdapter,
} from '@/apollo/adapters/modules/officeAdapter'
import { SelectOption } from '@/contracts/FormInput'

type InputOfficeMapProps = {
  label: string
  placeholder: string
  value: string
  noResultText: string
  searchable: boolean
  error: boolean | string
  rules: ReadonlyArray<string>
  excludesOffices: {
    enable: boolean
    offices: []
  }
}

export default defineComponent({
  name: 'InputOfficeMap',
  components: {
    SectionOffices,
    Popup,
    InputSelect,
  },
  model: {
    prop: 'value',
    event: 'input-change',
  },
  props: defineProps<InputOfficeMapProps>({
    label: {
      default: '',
    },
    placeholder: {
      default: '',
    },
    value: {
      default: '',
    },
    noResultText: {
      default: 'Введите город',
    },
    searchable: {
      default: false,
    },
    error: {
      default: false,
    },
    rules: {
      default: () => [''],
    },
    excludesOffices: {
      default: () => {
        return {
          enable: false,
          offices: [],
        }
      },
    },
  }),
  setup(props, { emit }) {
    const showPopup = ref(false)
    const { $api } = useContext()
    const router = useRouter()
    const errorMsg = ref<false | string>(false)
    const options = ref<AdaptedOfficeOption[]>([])
    const store = useStore()
    const region = computed(() => store.getters['region/getRegion'])
    const onClear = () => {
      // options.value = []
      emit('clear')
    }

    const clearOnRegionChange = () => {
      options.value = []
      emit('clear')
    }

    const hidePopup = () => {
      if (showPopup.value) router.push({ query: {} })
      showPopup.value = !showPopup.value
    }

    const changeOfiice = (office) => {
      if (
        props.excludesOffices.enable &&
        props.excludesOffices.offices?.find(
          (i) => i.value === office?.value?.branch_code
        )
      ) {
        office.excludeError = true
      } else if (office.name.includes('продаж')) {
        office.excludeError = true
      }
      emit('input-change', office)
    }

    const fetchOffices = async (region: string) => {
      try {
        const { data } = await $api.requests.getOffices({
          region,
          statAgentom: true,
        })
        if (data.status === 200) {
          const offices = officeListAdapter(data.data as Office[]).filter(
            (office) => {
              return (
                office?.title?.toLowerCase().includes('агентский центр') ||
                office?.title?.toLowerCase().includes('универсальный офис')
              )
            }
          )
          return offices
        } else {
          errorMsg.value = 'Ошибка загрузки'
        }
      } catch (e) {
        errorMsg.value = 'Ошибка загрузки'
      }
    }

    const validateSelect = (
      option: SelectOption<AdaptedOffice>,
      office: SelectOption<AdaptedOffice>
    ) => option.value.branch_code === office?.value?.branch_code

    const fetchOfficeOnRegionChange = async (): Promise<void> => {
      const offices = await fetchOffices(region.value)

      options.value =
        offices?.map((office) => ({
          name: office.title || office.address,
          value: office,
        })) || []
      if (
        props.value &&
        offices.some(
          (i) => i.title === props.value.name || i.address === props.value.name
        )
      ) {
        const choosenOffice = options.value.find(
          (office) => office.name === props.value.name
        )
        changeOfiice(choosenOffice)
      }
    }

    const fetchCities = debounce(500, async (city: string): Promise<void> => {
      const offices = await fetchOffices(region.value)

      if (city) {
        const resOffices = offices.filter((office) => {
          return office?.title?.toLowerCase().includes(city)
        })
        options.value =
          resOffices?.map((office) => ({
            name: office.title || office.address,
            value: office,
          })) || []
      }
    })

    const onChange = (event: RegionOption) => {
      if (
        props.excludesOffices.enable &&
        props.excludesOffices.offices?.find(
          (office) => office.value === (event.value as any).branch_code
        )
      ) {
        event.value.excludeError = true
      }
      emit('input', event)
    }

    return {
      changeOfiice,
      validateSelect,
      options,
      errorMsg,
      onChange,
      onClear,
      fetchCities,
      showPopup,
      hidePopup,
      region,
      fetchOfficeOnRegionChange,
      clearOnRegionChange,
    }
  },
  watch: {
    async region(value, oldValue) {
      if (value !== oldValue) {
        await this.fetchOfficeOnRegionChange()
      } else if (!value) {
        await this.clearOnRegionChange()
      }
    },
  },
})
